<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/seo-features.png" alt="seo" />
            </div>
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        مميزات أرشفة Codesroots
                    </h2>
                    <ul class="fa-ul text-right">
                        <li>
                            شر موقعك فى مواقع الويكي و مواقع gov والمنتديات
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            اك لينكس Do Follow فى مواقع ومنتديات ومحركات البحث
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            اشتراك بخدمة Google Analytics لمتابعة حالة الزوار و تحليل كيفية الوصول
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            حساب على Google Webmaster Tools لمتابعة روابط الموقع و حل الأخطاء
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            أنشاء خرائط للموقع [ xml, txt, php, xml.gz ]
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            تفعيل تغذية RSS داخل الموقع الخاص بك
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            ركيب إضافة VB SEO أو WP SEO على حسب موقعك
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            فحص وتحليل وضبط Meta Tags لموقعك
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            تقديم النصائح بخصوص محتوى الموقع
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>
                            حليل الموقع وإصلاح الأخطاء ومشاكل الارشفة
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
